__turbopack_context__.v({
  "carousel__container": "_4O-AYW_carousel__container",
  "carousel__cta-button": "_4O-AYW_carousel__cta-button",
  "carousel__header": "_4O-AYW_carousel__header",
  "carousel__header-container": "_4O-AYW_carousel__header-container",
  "carousel__header-container--secondary": "_4O-AYW_carousel__header-container--secondary",
  "carousel__item-wrapper": "_4O-AYW_carousel__item-wrapper",
  "carousel__title": "_4O-AYW_carousel__title",
  "carousel__title--secondary": "_4O-AYW_carousel__title--secondary",
  "carousel__title-icon": "_4O-AYW_carousel__title-icon",
  "carousel__wrapper": "_4O-AYW_carousel__wrapper",
  "wrapper": "_4O-AYW_wrapper",
});
